import { useState } from 'react'
import { apiFetch } from '../../../api/client'

type Props = {
  projectId: number
  initial: boolean
  onSaved?: (exclude: boolean) => void
}

export default function ForecastExcludeRow({ projectId, initial, onSaved }: Props) {
  const [exclude, setExclude] = useState(initial)
  const [busy, setBusy] = useState(false)

  async function toggle() {
    const next = !exclude
    setBusy(true)
    try {
      await apiFetch('PATCH', `/api/projects/${projectId}/forecast-exclude`, {
        exclude_from_forecast: next,
      })
      setExclude(next)
      onSaved?.(next)
    } finally {
      setBusy(false)
    }
  }

  return (
    <label
      style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13, marginTop: 12 }}
      data-testid="project-forecast-exclude"
    >
      <input type="checkbox" checked={exclude} disabled={busy} onChange={() => void toggle()} />
      <span>Exclude from cash forecast (scheduled billings)</span>
    </label>
  )
}
